import { CommonModule,isPlatformBrowser  } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnInit, OnChanges, PLATFORM_ID, Inject, HostListener, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms'; 

import { AnalysisServiceService } from './../services/analysis-service/analysis-service.service';

import { HttpClientModule } from '@angular/common/http';
import { FacadeService } from './../services/facade.service';
import { HttpClient } from "@angular/common/http";
import { ProyectosService } from '../services/proyectos.service';



@Component({
  selector: 'text-box',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule,
    HttpClientModule],
  templateUrl: './text-box.component.html',
  styleUrl: './text-box.component.css'
})
export class TextBoxComponent implements AfterViewInit, OnInit, OnChanges {
  buttonText: string = 'Copy Text';
  buttonImage: string = './assets/images/copy-text-icon.svg';
  buttonTextColor: string = '#EEA21A'; // Color inicial

  firstClick: boolean = true;

  message:boolean = false;
  InfolimitWords: boolean = false;
  currentAnalysisMode: string;
  currentTargetCEFR: string;
  achiveCEFR: string = "C2";

  userLimitWords: any;

  showAdvanced: boolean;

  loaderDocuments: boolean;

  title = 'Project Name or ID';
  isEditing = false;

  isEyeEditing = false;

  textAreaContent = 'Welcome to Text Inspector! To start, please replace this text here with the text you wish to inspect. You can either copy and paste your text here or import your text from a .txt or .doc file.\n \nAs you add text here, result will be shown on the right. ➔';
  @Input() disabled: boolean = false;
  @Input() textInputDisabled: boolean = false;
  @Input() checked: boolean = true;
  public text_data;
  
  @Output() checkedChange = new EventEmitter<boolean>();

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

private isDragging = false;
private startX = 0;
private scrollLeft = 0;

startDrag(event: MouseEvent): void {
  this.isDragging = true;
  this.startX = event.pageX - this.scrollContainer.nativeElement.offsetLeft;
  this.scrollLeft = this.scrollContainer.nativeElement.scrollLeft;
}

onDrag(event: MouseEvent): void {
  if (!this.isDragging) return;
  event.preventDefault();
  const x = event.pageX - this.scrollContainer.nativeElement.offsetLeft;
  const walk = (x - this.startX) * 1; // velocidad de arrastre
  this.scrollContainer.nativeElement.scrollLeft = this.scrollLeft - walk;
}

onWheel(event: WheelEvent): void {
  const container = this.scrollContainer.nativeElement;

  if (container.scrollWidth > container.clientWidth) {
    // Detecta si es rueda (saltos grandes) o touchpad (movimiento suave)
    const isMouseWheel = Math.abs(event.deltaY) > 15;

    if (isMouseWheel) {
      event.preventDefault(); // evita scroll vertical solo para rueda
    }

    container.scrollLeft += event.deltaY;
  }
}


stopDrag(): void {
  this.isDragging = false;
}


  @ViewChild('check',{read: ElementRef}) slide:ElementRef | undefined;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('textArea') textArea!: ElementRef<HTMLTextAreaElement>;

  view_button:boolean = true;
  limitOfDocuments:boolean = false;
  
  isScreenLarge: boolean = false;
  private inactivityTimer: any;
  
  checkIcon='M19.69,5.23L8.96,15.96l-4.23-4.23L2.96,13.5l6,6L21.46,7L19.69,5.23z';
  project_data: any;
  selectedWord: string;
  ngAfterViewInit(): void{

    if (this.slide) {
      const offIcon = this.slide.nativeElement.querySelector('.mdc-switch__icon--off path');
  
      if (offIcon) {
        offIcon.setAttribute('d', this.checkIcon);
      }
  
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['textInputDisabled']?.currentValue && this.textArea?.nativeElement) {
      this.textArea.nativeElement.blur();
    }
    this.adjustTextareaHeight();
  }

  enterMirrorEditMode(): void {
    // Mirror pilot paused for now. Keep the hook for quick reactivation later.
    // this.proyectoService.activatePilotMirrorEditing();
  }

  toggleChecked() {
    this.checkedChange.emit(this.checked);
    // Llamar al servicio para limpiar el marcado
    this.analysisService.limpiarMarcado();
  }

  toggleCopyState() {
    // this.highlightWord("powerbrokers")
    const textArea = this.textArea.nativeElement;
    textArea.select();
    document.execCommand('copy');
   
    this.buttonText = 'Text Copied';
    this.buttonImage = './assets/images/black_icons/copied-text-icon.svg';
    this.buttonTextColor = '#2A3654'; // Color negro de Texto copiado

    setTimeout(() => {
      this.buttonText = 'Copy Text';
      this.buttonImage = './assets/images/copy-text-icon.svg';
      this.buttonTextColor = '#EEA21A'; // Color amarillo para copiar texto
    }, 2000); // 2 segundos
  }

  editTitle() {
    this.isEditing = true;
    document.addEventListener('click', this.handleClickOutside);
  }

  saveTitle() {
    this.isEditing = false;
    document.removeEventListener('click', this.handleClickOutside);
      // Asegurar que el nombre no sea nulo o vacío antes de enviarlo
    if (this.text_data.name && this.text_data.name.trim() !== '') {
      this.updateProjectName(this.text_data.name);
    }
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.saveTitle();
    }
  }

  // Función que se ejecuta cuando se hace clic en cualquier parte del documento TITULO DEL PROYECTO
  handleClickOutside = (event: Event) => { 
    const target = event.target as HTMLElement; 
    if (!target.closest('.editable-input') && !target.closest('.editIcon')) { 
      this.saveTitle(); 
    }
  }

  constructor(
    private http:HttpClient,
    public fachada:FacadeService,
    public proyectoService: ProyectosService,
    @Inject(PLATFORM_ID) private platformId: Object,private analysisService: AnalysisServiceService) { }

  ngOnInit(): void {
    this.isButtonDisabled();
    this.userLimitWords = localStorage.getItem("Limit_words")
     // this.proyectoService.banderaLimpiarTexto$.subscribe(state =>{ //Para impedir lo del limite de texto (No exitosa)
    //   if(state){
    //      console.log("Entre a limpiar texto")
    //     this.InfolimitWords = false;
        
    //    const rawData = sessionStorage.getItem("analysis_op");
    //     if (rawData) {
    //       const parsedData = JSON.parse(rawData);
    //       this.textAreaContent = parsedData.text;
    //     }
    //   }
    // })
    this.adjust();
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    this.checkLimitWords()
    this.initSubscribe()
    this.initTextbox()
    this.showMessage()
    this.cleanClick()
    this.showAdvancedMode();

    this.proyectoService.showEditEye$.subscribe(state =>{
      this.isEyeEditing = state
    })

    this.analysisService.currentAnalysisMode.subscribe(mode => {
      this.currentAnalysisMode = mode;
    });

    this.analysisService.currentAchiveCEFR.subscribe(mode => {
      this.achiveCEFR = mode;
    });

    this.analysisService.currentTargetCEFR.subscribe(mode => {
      this.currentTargetCEFR = mode;
    });
    this.proyectoService.refreshTextBox$.subscribe(() => { 
      this.refreshComponent(); 
      this.showAdvancedMode();
      this.checked = false;
    });
    this.proyectoService.tabChanged$.subscribe(() => {
      this.initTextbox();
    });

    this.proyectoService.limitOfDocuments$.subscribe(state => {
      this.limitOfDocuments=state;
    });

    this.proyectoService.valueCopyButton$.subscribe(state => {
      this.view_button = state;
    });

    if(!sessionStorage.getItem("id_project")){
      this.title = 'Project Name or ID';
    }

     const container = document.querySelector('.center-align-documents');
    if (container) {
      container.addEventListener('wheel', (event: WheelEvent) => {
        if (event.deltaY !== 0) {  // si el scroll fue vertical
          event.preventDefault();  // evita el desplazamiento vertical
          container.scrollLeft += event.deltaY; // lo transforma en horizontal
        }
      });
    }
  }

  private refreshComponent() { 
    this.ngOnInit(); 
    this.title = 'Project Name or ID';
  }

  initSubscribe() {
    //Subscribimos al servicio para escuchar los datos
    this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
      this.project_data = proyecto;
      this.analysisService.changeEnglishType(this.project_data.config_json.englishType)
      this.analysisService.changeAnalysisMode(this.project_data.config_json.textmode)
      this.analysisService.changeTargetCEFR(this.project_data.config_json.target)
      this.analysisService.changeSplitCharacter(this.project_data.config_json.delimiter)
      this.initTextbox();
    });
    // Suscribimos al evento de proyecto guardado
    this.proyectoService.proyectoGuardado$.subscribe(() => {
       if(sessionStorage.getItem("id_project")){
        this.getNameProject();
       }
      this.showAdvancedMode();
    });
  }

  showAdvancedMode(){
    if(sessionStorage.getItem("id_project")){
      this.showAdvanced= true;
    }
    else{
      this.showAdvanced=false;
    }
  }
  
  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID"); 
  }

  highlightWord(palabra) {
    const regex = new RegExp(`(${palabra})`, 'gi');
    const salto = new RegExp(`(\n)`, 'gi');
    let highlightedText = this.textAreaContent.replace(salto, `<br>`);
    highlightedText = highlightedText.replace(regex, `<mark>$1</mark>`);
    document.getElementById('highlighted-content')!.innerHTML = highlightedText;
    document.getElementById('highlighted-content-specific')!.innerHTML = highlightedText;
  }

  sorted_related_projects: any[] = [];

async getNameProject() {
  let id_project = sessionStorage.getItem("id_project");
  try {

    this.loaderDocuments = true;
    let response = await this.fachada.getInfoProyect(this.http, id_project);

    this.text_data = response;

    // Nueva propiedad solo para mostrar en el front

    if (this.text_data.related_projects && Array.isArray(this.text_data.related_projects)) {
      // Normalizar + ordenar
      this.sorted_related_projects = this.text_data.related_projects
        .map(p => ({
          ...p,
          active: p.active === true || p.active === "true" ? "true" : "false"
        }))
        .sort((a, b) => a.id_project - b.id_project);
    } else {
      this.sorted_related_projects = [];
    }




    // ⚡️ Si solo hay 1, ocultamos la lista
    if (this.text_data.related_projects.length <= 1) {
      this.text_data.related_projects = [];
    }

    // Definir el título
    if (!this.text_data.name || this.text_data.name.trim() === "" || this.text_data.name === "Document 1") {
      this.title = this.text_data.text_UID;
    } else {
      this.title = this.text_data.name;
    }

    this.loaderDocuments = false;
  } catch (error) {
    console.error("No se obtuvo el nombre", error);
  }
}


async loadRelatedProject(project: any) {
  try {
    await this.proyectoService.getinfo(this.http, project.id_project);


    window.location.reload();
  } catch (error) {
    console.error("Error al cargar proyecto relacionado", error);
  }
}



  async initTextbox(){
    // this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
    //   this.text_data = updatedata;
    // });
     const rawData = sessionStorage.getItem("analysis_op");
     const actual = localStorage.getItem("actual")
    if(actual == "dashboard" || actual == "profile" ){
        try {
        let response = this.proyectoService.getdata()
        // let response = await this.fachada.getInfoProyect(this.http,1,"")
        this.text_data = response;
        this.textAreaContent = this.text_data.text
        this.adjustTextareaHeightWithContent();
        if (this.text_data.name==null || this.text_data.name === "Document 1"){
          this.title = this.text_data.text_UID
        }
        // console.log(response);
        this.limitWords();
      } catch (error) {
        console.log(error)
      }
    }
    if(!this.InfolimitWords && !rawData){
        try {
        let response = this.proyectoService.getdata()
        // let response = await this.fachada.getInfoProyect(this.http,1,"")
        this.text_data = response;
        this.textAreaContent = this.text_data.text
        this.adjustTextareaHeightWithContent();
        if (this.text_data.name==null || this.text_data.name === "Document 1") {
          this.title = this.text_data.text_UID
        }
        // console.log(response);
        this.limitWords();
      } catch (error) {
        console.log(error)
      }

       }else{
       this.InfolimitWords = false;
        this.proyectoService.updateBanderaLimpiarTexto(false)
     


      if (rawData) {
        try {
          const parsedData = JSON.parse(rawData);


           let textArea = document.getElementById("textArea") as HTMLTextAreaElement;
          textArea.value = parsedData.text;
          this.textAreaContent = parsedData.text;
          this.adjustTextareaHeightWithContent();
        } catch (error) {
          console.error(error);
        }
      }

    }
    

  }


  private startTimer() {
    if(!this.InfolimitWords){
      this.inactivityTimer = setTimeout(() => {
        this.onInactivity();  // Llama a la función después de 1.2 segundos de inactividad
        this.proyectoService.updateloader(false);
        this.proyectoService.updateloaderAnalyzing(true);
        this.proyectoService.verifyLoaderAnalyzing(true);
      }, 1200);  // 1200 ms = 1.2 segundos
    }
  }

  resetTimer() {
    if(!this.InfolimitWords){
      clearTimeout(this.inactivityTimer);  // Limpia el temporizador existente
      if(sessionStorage.getItem("id_project") && this.text_data.text.trim() !== ""){
        this.proyectoService.updateloader(true);
      }
      else{
        this.proyectoService.updateloader(false);
      }
      this.startTimer(); // Reinicia el temporizador
    }else{
      this.proyectoService.updateloader(false);
    }
                    
  }

  private async onInactivity() {
    if(!this.InfolimitWords){
      try {
        if(sessionStorage.getItem("id_project") && this.text_data.text.trim() !== ""){
          let response = await this.fachada.UpdateTextofProyect(this.http,this.text_data)
          this.text_data = response;
          this.proyectoService.updateData(this.text_data);
          this.textAreaContent = this.text_data.text
          if (this.text_data.name==null || this.text_data.name === "Document 1"){
            this.title = this.text_data.text_UID
          }
        }
        else{
          this.proyectoService.createValue.next(true)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.proyectoService.verifyLoaderAnalyzing(false);
        setTimeout(() => {
          this.proyectoService.updateloaderAnalyzing(false);
        }, 500);
      }
    }else{
      this.proyectoService.updateloader(false);
      this.proyectoService.updateDisablelimitOfWords(true);
      this.proyectoService.verifyLoaderAnalyzing(false);
          setTimeout(() => {
            this.proyectoService.updateloaderAnalyzing(false);
    }, 500); 
    }
  }

  private async updateProjectName(newName: string) {
    console.log('Actualizando solo el nombre del proyecto...');
    try {
      const idProject = sessionStorage.getItem("id_project");
      if (idProject) {
        let response = await this.fachada.UpdateNameofProyect(this.http, { id_project: idProject,name: newName});
        if (response && response.name) {
          this.title = response.name;
          console.log("Nombre del proyecto actualizado:", response.name);
          this.getNameProject();
        }
      } else {
        console.log("Error: No hay un ID de proyecto en sessionStorage.");
      }
    } catch (error) {
      console.log(error);
      console.log("No se pudo actualizar el nombre del proyecto");
    }
  }
  
  

  showMessage(){
    if(sessionStorage.getItem("id_project")){
      this.message = true;
    }
    else{
      this.message = false;
    }
  }

  adjustTextareaHeight() {
    if (this.textArea && this.textArea.nativeElement) {
      const textarea = this.textArea.nativeElement;
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }
  adjustTextareaHeightWithContent() {
    setTimeout(() => {
      let textArea = document.getElementById("textArea") as HTMLTextAreaElement;
      if (textArea) { 
        textArea.style.height = "auto";
        textArea.style.height = textArea.scrollHeight + "px";
      }
    }, 0); 
  }

  @HostListener('window:resize', ['$event'])
  adjust() {
    this.adjustTextareaHeightWithContent();
  }

  clearText(event: Event) {
    if(!sessionStorage.getItem("id_project")){
      if (this.firstClick) {
        this.text_data.text = "";
        this.firstClick = false;
      }
    }else{
      this.firstClick = true;
    }
  }

  cleanClick(){
    this.firstClick = true;
  }

  
  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }

  importText() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const content = e.target.result;
        // Crear un archivo temporal
        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        
        // Leer el archivo temporal
        fetch(url)
          .then(response => response.text())
          .then(text => {
            // Procesar el texto para eliminar caracteres no deseados
            const textContent = text.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');

            const words = textContent.split(/\s+/);

            
            if (words.length > Number(this.userLimitWords)) {
              this.InfolimitWords = true;
              this.proyectoService.updateDisablelimitOfWords(true);
              this.proyectoService.updateBanderaLimpiarTexto(true)
            } else {
              this.text_data.text = textContent;
              this.textAreaContent = textContent;
              this.InfolimitWords = false;
              this.proyectoService.updateBanderaLimpiarTexto(false)
              this.resetTimer();
            }

             // Ajustar el tamaño del textarea después de actualizar el contenido
            setTimeout(() => this.adjustTextareaHeightWithContent(), 0);
            this.firstClick = false;
            
            // Eliminar el archivo temporal
            URL.revokeObjectURL(url);
          });
      };
      reader.readAsText(file);
    }
  }

  showModal = false;

  onMouseEnter() {
    if (this.disabled==true) {
      this.showModal = true;
    }
  }

  onMouseLeave() {
    this.showModal = false;
  }

  closeModal() {
    this.showModal = false;
  }

  showModalMobile = false;

  onTabClickMobile() {
    if (this.disabled==true) {
      this.showModalMobile = true;
      setTimeout(() => {
        this.showModalMobile = false;
      }, 3000); // Desaparece después de 2 segundos
    }
  }


  checkLimitWords(): void {
    let content = this.textAreaContent;
    const words = content.split(/\s+/).filter(w => w.length > 0);;
    const isLessThan100Words = words.length < 100;
    this.proyectoService.updateWordCountStatus(isLessThan100Words); // Actualiza el estado en el servicio

    
     if (words.length > Number(this.userLimitWords)) {
      this.InfolimitWords = true;
      this.proyectoService.updateBanderaLimpiarTexto(true)
    } else {
      this.textAreaContent = content;
      this.InfolimitWords = false;
      this.proyectoService.updateBanderaLimpiarTexto(false)
    }
    
  }


   // Función para limitar las palabras a 250 en tiempo real
   limitWords(event: any = null): void {
    let content = this.textAreaContent;
    if (event) {
      content = event.target.value;
    }
    const words = content.split(/\s+/).filter(w => w.length > 0);;
    const isLessThan100Words = words.length < 100;
    this.proyectoService.updateWordCountStatus(isLessThan100Words); // Actualiza el estado en el servicio

     const wasOverLimit = this.InfolimitWords;

    
     if (words.length > Number(this.userLimitWords)) {
      this.InfolimitWords = true;
      this.proyectoService.updateBanderaLimpiarTexto(true)
    } else {
      this.textAreaContent = content;
      this.InfolimitWords = false;
      this.proyectoService.updateBanderaLimpiarTexto(false)
    }

    if (wasOverLimit) {
      this.resetTimer(); // <-- esto reinicia el análisis
    }
    
  }

  saveEdit(){
    this.proyectoService.updateloaderAnalyzing(true);
    this.proyectoService.verifyLoaderAnalyzing(true);
    this.proyectoService.updateEditEye(true);
    this.proyectoService.terminarEdicionErrores(this.http);
    this.proyectoService.showEditEye(false);
  }

}


